import React from 'react'
import Chatbot from '../ChatBot/Chatbot'
import AiUses from '../AIUses/AiUses'
import Comments from '../Comments/Comments'
import Disclaimer from '../Disclaimer/Disclaimer'
import FAQ from '../FAQ/FAQ'

const MeetNeo = () => {
    return (
        <>
            <Chatbot />

            <AiUses />

            <Comments />

            <Disclaimer />

            <FAQ />
        </>
    )
}

export default MeetNeo